import React from 'react'
import Box from '@material-ui/core/Box'
import AddBoxIcon from '@material-ui/icons/AddBox'

const Dropzone = ({ dropRef, canDrop }) => {
  return (
    <>
      {canDrop && (
        <Box
          ref={dropRef}
          sx={{
            mt: 1,
            border: 'dashed black',
            borderRadius: 5,
            height: '72px',
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <AddBoxIcon />
        </Box>
      )}
    </>
  )
}

export default Dropzone
